import moment from "moment";

export function isUnauthorized({ response }) {
  if (response && response.Error && response.Error.statusCode === 401) {
    removeUserDetailsFromLocalStorage();
  }
}

export function removeUserDetailsFromLocalStorage() {
  localStorage.removeItem("auth-token");
  localStorage.removeItem("userInstance");
  window.location.reload();
}

export function isKeyExistInObject(Object, Key) {
  return Key in Object;
}

export function isObjectEmpty(object) {
  if (object === null) {
    return true;
  }
  return Object.keys(object).length === 0;
}

export function getStatusClass(name) {
  let statusClass = "";
  if (name === "Awaiting Processing" || name === "AwaitingProcessing") {
    statusClass = "status-pending";
  } else if (name === "Pending") {
    statusClass = "status-pending";
  } else if (name === "Being Processed" || name === "BeingProcessed") {
    statusClass = "status-in-progress";
  } else if (name === "Accepted") {
    statusClass = "status-success";
  } else if (name === "Completed") {
    statusClass = "status-success";
  } else if (name === "Approved") {
    statusClass = "status-success";
  } else if (name === "Cancelled") {
    statusClass = "status-refund";
  } else if (name === "Refunded") {
    statusClass = "status-refund";
  } else if (name === "Processing Return" || name === "ProcessingReturn") {
    statusClass = "status-refund";
  } else if (name === "Returned Collected" || name === "ReturnedCollected") {
    statusClass = "status-success";
  } else if (
    name === "Returned Not Collected" ||
    name === "ReturnedNotCollected"
  ) {
    statusClass = "status-failed";
  } else if (name === "Rejected") {
    statusClass = "status-rejected";
  } else if (name === "Declined") {
    statusClass = "status-rejected";
  } else if (name === "Failed") {
    statusClass = "status-failed";
  } else if (name === "Hold") {
    statusClass = "status-onhold";
  } else if (
    name === "Awaiting Authorization" ||
    name === "AwaitingAuthorization"
  ) {
    statusClass = "status-in-progress";
  } else if (name === "Authorized") {
    statusClass = "status-in-progress";
  } else if (name === "Archived") {
    statusClass = "status-success";
  } else if (name === "Returned / Refunded" || name === "Returned/Refunded") {
    statusClass = "status-refund";
  } else if (
    name === "Authorization Expired" ||
    name === "AuthorizationExpired"
  ) {
    statusClass = "status-failed";
  } else if (name === "Being Settled" || name === "BeingSettled") {
    statusClass = "status-in-progress";
  } else if (name === "Settled") {
    statusClass = "status-success";
  } else if (name === "Returned Ineligible" || name === "ReturnedIneligible") {
    statusClass = "status-failed";
  } else if (name === "Vantiv Completed" || name === "VantivCompleted") {
    statusClass = "status-success";
  } else if (name === "Refund Processing" || name === "RefundProcessing") {
    statusClass = "status-in-progress";
  } else if (name === "NA") {
    statusClass = "status-failed";
  }

  return statusClass;
}

export function trimmer(object) {
  let obj = {};
  const array = Object.keys(object);
  const trimmedArray = array.map((item, index) => {
    const trimString =
      typeof object[item] === "string" ? object[item].trim() : object[item];
    return (obj[item] = trimString);
  });
  return obj;
}

export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const twoDigitsValidation = (n) => {
  if (n) {
    const values = String(n).split(".");
    if (values[1]) {
      console.log(values[1].length);
      return values[1].length < 3;
    } else {
      return true;
    }
  }
};

export const customRangeReport = {
  Today: [moment(), moment()],
  Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
  "Last 7 Days": [moment().subtract(6, "days"), moment()],
  "Last 30 Days": [moment().subtract(29, "days"), moment()],
  "This Week": [moment().startOf("week"), moment().endOf("week")],
  "This Month": [moment().startOf("month"), moment().endOf("month")],
  "This Year": [moment().startOf("year"), moment().endOf("year")]
};

export const customRangeReportWithoutDays = {
  "Last 7 Days": [moment().subtract(6, "days"), moment()],
  "Last 30 Days": [moment().subtract(29, "days"), moment()],
  "This Week": [moment().startOf("week"), moment().endOf("week")],
  "This Month": [moment().startOf("month"), moment().endOf("month")],
  "This Year": [moment().startOf("year"), moment().endOf("year")]
};

export const stringToDateWithFormat = (dateString) => {
  return new Date(dateString);
};

export const normalizeInputMobileNumber = (value, previousValue) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (!previousValue || value.length > previousValue.length) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};
